<template>
    <div class="vx-row">
        <div class="w-full vx-col">
            <vx-card class="p-4 mb-3" noShadow>
                <div class="vx-row mb-3">
                    <div class="w-full vx-col md:w-1/4 sm:w-1/3">
                        <label class="text-sm opacity-100 text-bold">Date From</label>
                        <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'Y-m-d' }"
                            v-model="fromDate" placeholder="Choose Date" />
                        <flat-pickr class="w-full" :config="{ dateFormat: 'Y-m-d' }" v-model="fromDate"
                            placeholder="Choose Date" />
                    </div>
                    <div class="w-full vx-col md:w-1/4 sm:w-1/3">
                        <label class="text-sm opacity-100 text-bold">To From</label>
                        <flat-pickr style="display: none" class="w-full" :config="{ toDate: 'Y-m-d' }" v-model="fromDate"
                            placeholder="Choose Date" />
                        <flat-pickr class="w-full" :config="{ dateFormat: 'Y-m-d' }" v-model="toDate"
                            placeholder="Choose Date" />
                    </div>
                </div>
                <div class="mt-5 vx-row">
                    <div class="w-full ml-auto vx-col">
                        <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                            v-on:click="onClearFilter">CLEAR</vs-button>
                    </div>
                </div>
            </vx-card>
            <vx-card>
                <vs-table stripe sort class="mt-8" :data="filteredData">
                    <template slot="thead">
                        <vs-th width="10%">CAMPAIGN ID</vs-th>
                        <vs-th width="20%">CAMPAIGN NAME</vs-th>
                        <vs-th width="15%">CREATED DATE/TIME</vs-th>
                        <vs-th width="15%">RECIPIENTS LIST NAME</vs-th>
                        <vs-th width="10%">SENT TO</vs-th>
                        <vs-th width="5%">OPENED</vs-th>
                        <vs-th width="5%">CLICKED</vs-th>
                        <vs-th width="20%">ACTION</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                            <vs-td>
                                {{ data[indextr].id }}
                            </vs-td>

                            <vs-td>
                                {{ data[indextr].settings.preview_text || 'N/A' }}
                            </vs-td>

                            <vs-td>
                                {{ __dateTimeFormatter(tr.create_time) }}
                            </vs-td>

                            <vs-td>
                                {{ data[indextr].recipients.list_name || 'N/A' }}
                            </vs-td>

                            <vs-td>
                                {{ data[indextr].recipients.recipient_count || 'N/A' }}
                            </vs-td>

                            <vs-td>
                                {{ data[indextr].report_summary ? data[indextr].report_summary.opens : 'N/A' }}
                            </vs-td>

                            <vs-td>
                                {{ data[indextr].report_summary ? data[indextr].report_summary.clicks : 'N/A' }}
                            </vs-td>


                            <vs-td>
                                <div class="justify-start vx-row">
                                    <!-- <vx-tooltip text="Open report" position="top" v-if="!!data[indextr].report_summary">
                                        <vs-button @click.stop="onClickViewOpenReport(data[indextr].id)"
                                            class="ml-3" size="small" color="primary" type="border" icon-pack="feather"
                                            icon="icon-mail"></vs-button>
                                    </vx-tooltip> -->
                                    <vx-tooltip text="Email activity report" position="top"
                                        v-if="!!data[indextr].report_summary">
                                        <vs-button @click.stop="onClickViewEmailActivityReport(data[indextr].id)"
                                            class="ml-3" size="small" color="primary" type="border" icon-pack="feather"
                                            icon="icon-mail"></vs-button>
                                    </vx-tooltip>
                                </div>
                            </vs-td>

                        </vs-tr>
                    </template>
                </vs-table>
            </vx-card>
        </div>
        <ViewCampaignOpenReportPopUp ref="viewCampaignOpenReportPopUp" />
        <ViewCampaignEmailActivityReportPopUp ref="viewCampaignEmailActivityReportPopUp" />
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
const CrmRepository = RepositoryFactory.get('crm');
import ViewCampaignOpenReportPopUp from '@/components/popups/crm/aggregated-activities/ViewCampaignOpenReportPopUp.vue'
import ViewCampaignEmailActivityReportPopUp from '@/components/popups/crm/aggregated-activities/ViewCampaignEmailActivityReportPopUp.vue'
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'

export default {
    name: 'CustomerCrmCampaignList',
    data() {
        return {
            campaign_list: [],
            customerId: null,
            fromDate: null,
            toDate: null
        }
    },
    components: {
        ViewCampaignOpenReportPopUp,
        ViewCampaignEmailActivityReportPopUp,
        flatPickr
    },
    methods: {
        async fethCampaignList() {
            try {
                const { data } = await CrmRepository.fetchCampaignList()
                this.campaign_list = data.campaigns
            } catch (error) {

            }
        },
        async onClickViewOpenReport(id) {
            this.$refs.viewCampaignOpenReportPopUp.openPopup(id)
        },
        async onClickViewEmailActivityReport(id) {
            this.$refs.viewCampaignEmailActivityReportPopUp.openPopup(id, this.customerId)
        },
        onClearFilter() {
            this.fromDate = null
            this.toDate = null
        }
    },
    async mounted() {
        this.customerId = this.$route.params.id
        await this.fethCampaignList()
    },
    computed: {
        filteredData() {
            const fromDate = this.fromDate ? moment(this.fromDate, 'YYYY-MM-DD') : null;
            const toDate = this.toDate ? moment(this.toDate, 'YYYY-MM-DD') : null;

            return this.campaign_list.filter(item => {
                const date = moment(item.create_time, moment.ISO_8601);

                if (fromDate && toDate) {
                    return date.isBetween(fromDate, toDate, null, '[]');
                } else if (fromDate) {
                    return date.isSameOrAfter(fromDate);
                } else if (toDate) {
                    return date.isSameOrBefore(toDate);
                }
                return true;
            });
        }
    }
}
</script>
<style lang="">
    
</style>